import { SwaggerParser } from './swagger';
import { ApiParserBase } from './types';
import { OpenApi3Parser } from './openapi3';
//namespace Pacem.Scaffolding.OpenApi {
export class OpenApiParser extends ApiParserBase {
    constructor(_openApi3 = new OpenApi3Parser(), _swagger = new SwaggerParser()) {
        super();
        this._openApi3 = _openApi3;
        this._swagger = _swagger;
    }
    parse(content, url) {
        let j = content;
        if (typeof j === 'string') {
            j = JSON.parse(j);
        }
        const json = j;
        if ('openapi' in json) {
            return this._openApi3.parse(json, url);
        }
        return this._swagger.parse(json, url);
    }
}
//}
